import IconCopy from 'app/components/shared/app/icons/IconCopy';
import Button from 'components/shared/app/Button';
import Spinner from 'components/shared/app/Spinner';
import FacebookDataProvider from 'lib/data/providers/FacebookDataProvider';
import ShopifyDataProvider from 'lib/data/providers/ShopifyDataProvider';
import NotificationService from 'lib/services/NotificationService';
import { copyToClipboard, getAccountProviders, getInnerError } from 'lib/utils/adaya/AdayaUtils';
import React, { useEffect, useState } from 'react';
import AccountService from 'services/AccountService';
import GoogleConnectBtn from 'static/images/btn_google_signin_dark_normal_web@2x.png';
import { generateShopifyAuthorizationUrl } from 'utils/adaya/ShopifyUtils';
import { renderDataRow } from '../utils/render';
import './style.scss';

interface IProps {
    auth: AuthProvider;
}

const Providers = (props: IProps) => {
    const [modalActive, setModalActive] = useState(false);
    const [shopifyStoreUrl, setShopifyStoreUrl] = useState('');
    const [activeAccount, setActiveAccount] = useState(null);

    const user = props.auth.user;
    const account = user?.activeAccount;
    const providers = getAccountProviders(account);

    useEffect(() => {
        //if (account) {}
    }, [user]);

    // Todo: maybe move all these to their own components, subclassed, use props, whee.

    // custom data render per provider
    const _providerRenders = {
        Amazon: (p) => {
            const [loading, setLoading] = useState(false);

            const redirect = async () => {
                window.location.href = `${process.env.CLIENT_URL}/amazon_ads-authorize`;
            };

            const disconnectAmazon = async () => {
                if (confirm('Are you sure you want to disconnect this Amazon account? This will remove all of your stored TikTok insights data.')) {
                    try {
                        setLoading(true);
                        let newUser = await props.auth.disconnectProvider(account, p);
                        console.log(`disconnect result`, newUser);
                    } catch (e) {
                        console.error('Exception disconnecting Amazon:', e);
                        NotificationService.notifyError('Error', getInnerError(e));
                    }
                    setLoading(false);
                }
            };

            let r = [];

            if (p.oauth) {
                r.push(renderDataRow('Connected To', p.oauth.clientId));

                if (p.data?.customer) {
                    r.push(renderDataRow('Customer', <span>{p.data.customer}</span>));
                }

                if (p.data?.login_customer_id) {
                    r.push(renderDataRow('Manager', <span>{p.data.login_customer_id}</span>));
                }

                if (p.dateLinked) {
                    r.push(renderDataRow('Date Linked', <span>{moment(p.dateLinked).format('LLL')}</span>));
                }
            }

            // push provider actions to separate area
            r.push(
                <div className="provider-actions">
                    {p.oauth
                        ? renderDataRow(
                              '',
                              <Button size="small" round simple bold filled center color="blue" onClick={disconnectAmazon}>
                                  Disconnect Amazon Ads
                              </Button>
                          )
                        : renderDataRow(
                              '',
                              <Button size="small" round simple bold filled center color="blue" onClick={redirect}>
                                  Connect Amazon Ads
                              </Button>
                          )}
                </div>
            );

            if (loading)
                r.push(
                    <div className="provider-loader">
                        <Spinner size="small" color="blue" />
                    </div>
                );

            return r;
        },

        TikTok: (p) => {
            const [loading, setLoading] = useState(false);

            const redirect = async () => {
                window.location.href = `${process.env.CLIENT_URL}/tiktok-authorize`;
            };

            const disconnectTikTok = async () => {
                if (confirm('Are you sure you want to disconnect this TikTok account? This will remove all of your stored TikTok insights data.')) {
                    try {
                        setLoading(true);
                        let newUser = await props.auth.disconnectProvider(account, p);
                        console.log(`disconnect result`, newUser);
                    } catch (e) {
                        console.error('Exception disconnecting TikTok:', e);
                        NotificationService.notifyError('Error', getInnerError(e));
                    }
                    setLoading(false);
                }
            };

            let r = [];

            if (p.oauth) {
                r.push(renderDataRow('Connected To', p.oauth.clientId));

                if (p.data?.customer) {
                    r.push(renderDataRow('Customer', <span>{p.data.customer}</span>));
                }

                if (p.data?.login_customer_id) {
                    r.push(renderDataRow('Manager', <span>{p.data.login_customer_id}</span>));
                }

                if (p.dateLinked) {
                    r.push(renderDataRow('Date Linked', <span>{moment(p.dateLinked).format('LLL')}</span>));
                }
            }

            // push provider actions to separate area
            r.push(
                <div className="provider-actions">
                    {p.oauth
                        ? renderDataRow(
                              '',
                              <Button size="small" round simple bold filled center color="blue" onClick={disconnectTikTok}>
                                  Disconnect TikTok
                              </Button>
                          )
                        : renderDataRow(
                              '',
                              <Button size="small" round simple bold filled center color="blue" onClick={redirect}>
                                  Connect TikTok
                              </Button>
                          )}
                </div>
            );

            if (loading)
                r.push(
                    <div className="provider-loader">
                        <Spinner size="small" color="blue" />
                    </div>
                );

            return r;
        },

        Google: (p) => {
            const redirect = async () => {
                window.location.href = `${process.env.CLIENT_URL}/googleads-authorize`;
            };

            const disconnectGoogle = async () => {
                if (confirm('Are you sure you want to disconnect this Google account? This will remove all of your stored Google Ad insights data.')) {
                    try {
                        // todo: route to AuthProvider disconnectProvider...
                        let newUser = await props.auth.disconnectProvider(account, p);
                    } catch (e) {
                        console.error('Exception disconnecting google:', e);
                        NotificationService.notifyError('Error', getInnerError(e));
                    }
                }
            };

            let r = [];

            if (p.oauth) {
                r.push(renderDataRow('Connected To', p.oauth.clientId));

                if (p.data?.customer) {
                    r.push(renderDataRow('Customer', <span>{p.data.customer}</span>));
                }

                if (p.data?.login_customer_id) {
                    r.push(renderDataRow('Manager', <span>{p.data.login_customer_id}</span>));
                }

                if (p.dateLinked) {
                    r.push(renderDataRow('Date Linked', <span>{moment(p.dateLinked).format('LLL')}</span>));
                }
            }

            // push provider actions to separate area
            r.push(
                <div className="provider-actions">
                    {p.oauth
                        ? renderDataRow(
                              '',
                              <Button size="small" round simple bold filled center color="blue" onClick={disconnectGoogle}>
                                  Disconnect Google
                              </Button>
                          )
                        : renderDataRow(
                              '',
                              <span onClick={redirect}>
                                  <img width="191" height="46" src={GoogleConnectBtn}></img>
                              </span>
                          )}
                </div>
            );

            return r;
        },

        Shopify: (p) => {
            if (!p.oauth || !p.data || !p.data.shop) return '(not connected)';
            let r = [
                renderDataRow(
                    'Shop',
                    <a href={`https://${p.data.shop}`} target="_blank">
                        {p.data.shop}
                    </a>
                )
            ];
            if (p.data.currency) {
                r.push(renderDataRow('Currency', p.data.currency));
            }
            if (p.data.timezone) {
                r.push(renderDataRow('Timezone', p.data.timezone));
            }

            if (p.dateLinked) {
                r.push(renderDataRow('Date Linked', <span>{moment(p.dateLinked).format('LLL')}</span>));
            }
            return r;
        },

        Facebook: (p) => {
            if (!p.oauth || !p.data) return '(not connected)';

            let pixelId = p.data.pixelId || '';
            let token = p.data.conversionAccessToken || '';

            // saves the provider data, and updates local user in app.
            const saveProvider = async () => {
                // update the user...
                let newUser = await AccountService.updateAccountProvider(account._id, p);
                if (newUser) {
                    await props.auth.updateUserLocal(newUser);
                    NotificationService.notifySuccess('Success', 'Facebook data has been updated. Please ensure you have the latest Tracking snippet on your store.');
                } else {
                    NotificationService.notifyError('Error', 'An unknown error has occurred.');
                }
            };

            const savePixelId = (e) => {
                p.data.pixelId = pixelId;
                saveProvider();
            };

            const saveAccessToken = async (e) => {
                p.data.conversionAccessToken = token;
                await saveProvider();
            };

            let r = [];
            if (p.data.currency) {
                r.push(renderDataRow('Currency', p.data.currency));
            }
            if (p.data.timezone) {
                r.push(renderDataRow('Timezone', p.data.timezone));
            }

            r.push(
                renderDataRow(
                    'Pixel ID',
                    <div className="input">
                        <input type="text" placeholder="Pixel ID" defaultValue={pixelId} onChange={(e) => (pixelId = e.target.value)} />
                        <Button size="small" round simple bold filled center color="blue" onClick={savePixelId}>
                            Save
                        </Button>
                        <IconCopy onClick={() => copyToClipboard(pixelId)} color="black" />
                    </div>
                )
            );

            r.push(
                renderDataRow(
                    'Conversions API Access Token',
                    <div className="input">
                        <textarea placeholder="Token" rows="3" defaultValue={token} onChange={(e) => (token = e.target.value)} />
                        <Button size="small" round simple bold filled center color="blue" onClick={saveAccessToken}>
                            Save
                        </Button>
                        <IconCopy onClick={() => copyToClipboard(token)} color="black" />
                    </div>
                )
            );

            if (p.dateLinked) {
                r.push(renderDataRow('Date Linked', <span>{moment(p.dateLinked).format('LLL')}</span>));
            }

            // if (error) {
            //     r.push(renderDataRow("Error", error));
            // }

            return r;
        }
    };

    const ALL_PROVIDERS = [
        {
            name: 'Shopify',
            render: _providerRenders.Shopify,
            alwayShow: true, // always render this provider on Account page, even if not connected
            provider: ShopifyDataProvider // just serves as a reference if needed
        },
        {
            name: 'Facebook',
            render: _providerRenders.Facebook,
            alwayShow: true, // always render this provider on Account page, even if not connected
            provider: FacebookDataProvider // just serves as a reference if needed
        },
        {
            name: 'Google',
            render: _providerRenders.Google,
            alwayShow: true, // always render this provider on Account page, even if not connected
            provider: null // GoogleProvider // just serves as a reference if needed
        },
        {
            name: 'TikTok',
            render: null, //_providerRenders.Google,
            alwayShow: true, // always render this provider on Account page, even if not connected
            provider: null // GoogleProvider // just serves as a reference if needed
        },
        {
            name: 'Amazon',
            render: _providerRenders.Amazon, //_providerRenders.Google,
            alwayShow: true, // always render this provider on Account page, even if not connected
            provider: null // GoogleProvider // just serves as a reference if needed
        },
        {
            name: 'FictionalProvider',
            render: null, //_providerRenders.Google,
            alwayShow: false, // always render this provider on Account page, even if not connected
            provider: null // GoogleProvider // just serves as a reference if needed
        }
    ];

    const redirectToShopifyAuthorization = () => {
        let url = generateShopifyAuthorizationUrl(shopifyStoreUrl);
        if (url) {
            window.location.href = url;
        }
    };

    const _renderProvider = p => {
        let r = _providerRenders[p.name];
        return r ? (
            <div className="provider-data data-rows">
                {r(p)}
            </div>)
            : undefined;
    };

    return (
        <div className="providers-list card-panel">
            {
                ALL_PROVIDERS.map((p, i) => {
                    let x = providers.find(x => x.name === p.name);
                    return (x || (!x && p.alwayShow)) ?
                        (
                            <div key={i + p.name} className="card provider-box">
                                <h3 className="label">{p.name}</h3>
                                <div className="provider-details">
                                    {_renderProvider(x ?? p)}
                                </div>
                            </div>
                        ) :
                        undefined;
                })
            }
        </div>
    );
};

/* <Modal active={modalActive} toggleActive={setModalActive}>

    <div className="providers-modal">

        <h3 className="header">Enter Your Shopify Store URL:</h3>

        <input type="text" placeholder="example-store.myshopify.com" className="input simpl0 margin md ns" onChange={(e) => setShopifyStoreUrl(e.target.value)} />

        <div className="button color-green filled round" onClick={redirectToShopifyAuthorization}>Connect to Shopify</div>

    </div>

</Modal> */

export default Providers;
